import moment from "moment";
import { useRecoilState } from "recoil";
import myInfoState from "../../atoms/myinfo";
import "./MyInfo.scoped.scss"

function MyInfo() {
  const [myInfo] = useRecoilState(myInfoState);

  const thumbnailUrlTailer = Math.floor(moment().unix() / 60);

  const thumbnailUrl = myInfo.userDetail?.hasThumbnail
      ? `/data/member_image/${myInfo.id.substring(0, 2)}/${myInfo.id}.gif?${thumbnailUrlTailer}`
      : '/img/profile.png';

  return (
    <div className="my-info">
			<div className="my-info__header">내정보</div>
			<div className="my-info__contents">
        <img
          className="my-info__thumbnail"
          src={thumbnailUrl}
          alt=""
        />
				<img 
          className="my-info__icon"
          src={`/img/level/level_img/${myInfo.userDetail?.level ? myInfo.userDetail?.level : 1}.png`} 
          alt=""
        />
				<span>{
          (myInfo.userDetail?.nickname && myInfo.userDetail?.nickname !== '')
            ? myInfo.userDetail?.nickname 
            : myInfo.id 
        }</span>
        {
        (myInfo.userDetail?.todayComment && myInfo.userDetail?.todayComment !== '')
          ? (
            <div className="my-info__message">
              <div>
                <span>{myInfo.userDetail?.todayComment }</span>
              </div>
            </div>
          )
          : null
        }
			</div>
    </div>
  );
}

export default MyInfo;
